export default __webpack_public_path__ + "static/media/Quote.e83ec53d.webp";